
import Vue from "vue";
import HeaderDropDownFilter, {
  OptionItem,
} from "@/components/BaseHeaderDropDownFilter.vue";

export type FilterCondition = {
  type?: string;
  battery?: string;
  status?: string;
};

export type DataType = {
  filterCondition: FilterCondition;
  typeOptions: Array<OptionItem>;
  batteryOptions: Array<OptionItem>;
  statusOptions: Array<OptionItem>;
};

export default Vue.extend({
  name: "SensorListHeader",

  components: {
    HeaderDropDownFilter,
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    },
  },

  data(): DataType {
    return {
      filterCondition: {
        type: undefined,
        battery: undefined,
        status: undefined,
      },
      typeOptions: [
        {
          label: "ドアセンサ-R1",
          value: "door-r1",
        },
        {
          label: "ドアセンサ-V1",
          value: "door-v1",
        },
        {
          label: "ドアセンサ-V2",
          value: "door-v2",
        },
        {
          label: "新 MIC",
          value: "mic",
        },
        {
          label: "人感センサ-V1",
          value: "infrared-v1",
        },
        {
          label: "サーモセンサー",
          value: "thermopile",
        },
      ],
      batteryOptions: [
        {
          label: "High",
          value: "75",
          classes: ["green"],
        },
        {
          label: "Mid",
          value: "40",
          classes: ["green"],
        },
        {
          label: "Low",
          value: "20",
          classes: ["orange"],
        },
        {
          label: "Low",
          value: "10",
          classes: ["red"],
        },
      ],
      statusOptions: [
        {
          label: "稼動",
          value: "running",
        },
        {
          label: "停止",
          value: "stopped",
          classes: ["red"],
        },
      ],
    };
  },

  methods: {
    updateFilterConditionAndSearch(): void {
      this.$emit("update-filter-condition", this.filterCondition);
      this.$emit("search");
    },
  },
});
